import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import {
  setModalCadastrarDetalheConfiguracaoImportacaoVenda,
  setModalDeletarDetalheConfiguracaoImportacaoVenda,
} from "../redux/slices/detalheConfiguracaoImportacaoVenda/detalheConfiguracaoImportacaoVendaSlice";

export const cadastrarDetalheConfiguracaoImportacaoVenda = createAsyncThunk("/DetalheConfiguracaoImportacaoVenda/CadastrarDetalheConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/DetalheConfiguracaoImportacaoVenda/CadastrarDetalheConfiguracaoImportacaoVenda/", payload.value);
    toastSucess("Vigência cadastrada com sucesso");
    dispatch(setModalCadastrarDetalheConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarDetalheConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const listarDetalheConfiguracaoImportacaoVenda = createAsyncThunk("/DetalheConfiguracaoImportacaoVenda/BuscarDetalheConfiguracaoImportacaoVenda", async (idEmpresa: number) => {
  try {
    const data = await api.get("/DetalheConfiguracaoImportacaoVenda/BuscarDetalheConfiguracaoImportacaoVenda", {
      params: { idEmpresa: idEmpresa },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarDetalheConfiguracaoImportacaoVenda = createAsyncThunk("/DetalheConfiguracaoImportacaoVenda/AtualizarDetalheConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/DetalheConfiguracaoImportacaoVenda/AtualizarDetalheConfiguracaoImportacaoVenda/", payload.value);
    toastSucess("Vigência atualizada com sucesso");
    dispatch(setModalCadastrarDetalheConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarDetalheConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarDetalheConfiguracaoImportacaoVenda = createAsyncThunk("/DetalheConfiguracaoImportacaoVenda/DeletarDetalheConfiguracaoImportacaoVenda", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/DetalheConfiguracaoImportacaoVenda/DeletarDetalheConfiguracaoImportacaoVenda/", { params: { id: payload.value } });
    toastSucess("Vigência removida com sucesso");
    dispatch(setModalDeletarDetalheConfiguracaoImportacaoVenda(false));
    dispatch(setLoading(false));

    dispatch(listarDetalheConfiguracaoImportacaoVenda(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
